export default "__VITE_ASSET__C77Qn$_Y__"